import React, { Component } from 'react';
import { connect } from 'react-redux'
import Modal from 'react-modal';
import PropTypes from 'prop-types'
import FormContent from './FormContent';
import { MODAL_FOLDER_FORM, MODAL_SLIDER_FOLDER_FORM, hideModal } from '../../../../../../modules/modals';

class FormModal extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  handleClose = () => {
    const { hideModal } = this.props;
    hideModal({ modalType : MODAL_SLIDER_FOLDER_FORM});

  }

  getTitle = () => {
    const {initialValues} = this.props;
    const {formatMessage} = this.context
    let text = typeof initialValues.id != 'undefined' ? "frmTitleUpdateSliderFolder" : "frmTitleAddNewSliderFolder"
    return <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>;
  }

  render() {
    const { zIndex } = this.props;
    return (
      <Modal
          isOpen = {true}
          style = {{
              overlay : {zIndex},
          }}
          onRequestClose={this.handleClose}
          overlayClassName = "custom-modal"
          className = "custom-modal-content create-dialog-modal-content"
      >
          <div className="create-dialog-modal-content__header">
              {
                this.getTitle()
              }
              <div
                  onClick={this.handleClose}
                  className="create-dialog-modal-content__close"
              ></div>
          </div>
          <div className="create-dialog-modal-content__body">
            <FormContent {...this.props} handleClose={this.handleClose} />
          </div>
      </Modal>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  hideModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(FormModal)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Sliders/components/Folders/components/FormModal/index.jsx